import { render, staticRenderFns } from "./CategoryLinkCard.vue?vue&type=template&id=6833a21c"
import script from "./CategoryLinkCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryLinkCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports